import React, { Component } from 'react'
import { connect } from 'react-redux'
import { grantMeProjectAccess } from '../../../../store/actions/companyActions';
import Loader from 'react-loader-spinner';

class TransferCreatorCredentialsModal extends Component {
    constructor(props) {
        super(props)

        this.state = {

        }
    }


    /// README: CALLING CLOUD FUNCTION TO GRANT MYSELF PROJECT ACCESS
    grantProjectAccess = () => {
        const { userData, companyData, projectModelJson } = this.props;

        this.props.grantMeProjectAccess(userData, companyData, projectModelJson);
    }

    render() {

        const { modalWidth, modalTitleStyle, modalInfoTextStyle,commons,company } = this.props;
        const{capiMessage,showCapiLoader} = company;
        return (
            <div className="dynamicModalContainer">
                <div className="dynamicModalSm">
                    <p style={modalTitleStyle}>Must read this before proceeding:</p>
                    <p style={modalInfoTextStyle}>* You are going to grant yourself as the main admin of this {commons.project}.</p>
                    <p style={modalInfoTextStyle}>* We assume that you are willingly taking this action for which AssetTag will not be responsible.</p>
                    <br />
                    <div className="btn btn-danger btn-sm float-right" style={{ borderRadius: '10px' }} onClick={() => this.grantProjectAccess()}>Grant me {commons.project} access now</div>
                </div>
                {
                    showCapiLoader?
                    <Loader
                    type="TailSpin"
                    color={this.props.themeColors.themeColor}
                    height={20}
                    width={20}
                />:<React.Fragment/>
                }
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        themeColors: state.theme,
        alu: state.alu,
        floor: state.floor,
        company: state.company,
        formLabelStyle: state.appControl.formLabelStyle,
        modalStyles: state.appControl.modalStyles,
        modalWidth: state.appControl.modalWidth,
        modalTitleStyle: state.appControl.modalTitleStyle,
        modalInfoTextStyle: state.appControl.modalInfoTextStyle,

        companyData: state.firestore.data.Company,
        userData: state.firebase.profile,
        userId: state.firebase.auth.uid,
        companyBriefingsData: state.firestore.data.CompanyBriefings,
        commons:state.commons,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        grantMeProjectAccess: (creatorUserModelJson, companyModelJson, projectModelJson) => dispatch(grantMeProjectAccess(creatorUserModelJson, companyModelJson, projectModelJson)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(TransferCreatorCredentialsModal)
